export default __webpack_public_path__ + "static/media/Food.b8345b18.svg";